import jbAPI from "./jobboard";

console.log("empoyer api ");
export const fetchEmployerDetailbyID = async (employer_id, token) => {
  console.log("employer_id ::: ",employer_id);
  try {
    const response = await jbAPI.get(`/employer/${employer_id}/profile`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    console.log(" ooooooooooooo : ",response.data);
    return response.data;
  } catch (error) {
    console.error("Failed to fetch employer detail:", error);
    throw error;
  }
};

export const updateEmployerProfile = async (employer_id, employerPayload, token) => {
  console.log("employerPayload ::: ",employerPayload);
  try {
    const response = await jbAPI.put(`/updateEmployerProfile`, 
       employerPayload,
      {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });   
   
    return response.data;
  } catch (error) {
    console.error("Failed to update employer detail:", error);
    throw error;
  }
};